
import React from 'react'
import { Helmet } from 'react-helmet';
import { useMediaQuery } from 'react-responsive'
import { useNavigate, Link } from "react-router-dom"
import Button from '../../components/Button'
import Return from '../../components/Forum/Return'
import CommentIcon from '../../images/comment.svg'
import LikeIcon from '../../images/like.svg'

export default function Post9() {

  const tabletBreakpoint = useMediaQuery({ query: '(min-width: 768px)' })

  const navigate = useNavigate()

  React.useEffect(() => { 
    window.scrollTo(0, 0)
  }, [])


  return (

    <div className="top-margin-s">

      <Helmet>
        <title>Dúvida saúde - geral - Sobre perda e controle do peso</title>
        <meta 
          name="description" 
          content="Controlar meu peso foi a primeira coisa onde foquei depois do meu diagnóstico com colesterol alto. Eu estava com obesidade, e precisava reduzir meu peso de maneira sustentável e saudável. Com isso em mente, estudei e apliquei o que aprendi. 

Algumas coisas que não sabia, mas que me aproximaram da realidade, são que pessoas que estão acima do seu peso ideal tem:

1) Maior risco de tornarem-se diabéticos.
2) Maior risco de tornarem-se hipertensos.
3) Maior risco de câncer de mama.
4) Maior risco de câncer de cólon.
5) Existe uma correlação direta entre sobrepeso e doenças cardíacas.

Com conhecimento sobre esses pontos comecei a trabalhar em desenvolver uma alimentação que me permitisse perder peso, e sustentar meu novo peso saudável. Notem aqui algo super importante, que nem sempre é evidente: a sua dieta para perda de peso precisa ser a sua nova rotina de alimentação como um todo, e não algo que você vai fazer algumas semanas enquanto perde peso, e depois vai parar e voltar para o que era antes. Se isso acontecer, todo o peso que você perdeu vai voltar em pouco tempo e com alguns kilos a mais.

PONTO CHAVE: A dieta de perda de peso precisa se tornar a nova rotina de alimentação como um todo.

Então, o ponto chave é: sua alimentação para perda de peso precisa ser sua alimentação para sustentar aquele peso. Ou seja, precisa ser sua nova educação alimentar, seu novo e permanente estilo de vida para alimentação.

Para montar seu novo estilo de vida alimentar é legal ter a ajuda de um nutricionista que te conhece. Mas alguns pontos gerais que eu usei e podem ser úteis:

O número de calorias que você consome menos o número de calorias que você queima determina se você irá ganhar ou perder peso. É importante focar em comidas que irão te dar a sensação de estar cheio/satisfeito com o menor número de calorias: comidas ricas em fibra, frutas e vegetais são ótimas opções, e devem fazer parte integral da nova alimentação (foque em no mínimo 3 frutas por dia!).

Corte os lanches durante o dia e a sobremesa enquanto você estiver tentando perder peso. E após ter chegado no seu peso ideal, esses lanches devem ser frutas.

Cuidado com o tamanho das porções. Mas coma quantos vegetais e frutas quiser, esses são livres!

Evite frituras. Elas adicionam cerca de um terço a mais de calorias. Prefira grelhados ou assados.

Faça exercícios: suas chances de perder peso e manter o peso ideal são muito melhores se você se exercitar. Até mesmo uma caminhada algumas vezes por dia é 1000 vezes melhor do que ficar sentado na frente da TV."/>
      </Helmet>

      <div className={(tabletBreakpoint) ? 
        "container-simple-tablet" : "container-simple"}>
        <div className="top-margin-s bottom-margin-s">
          <Return to='/forum' />
        </div>
        <div className="bottom-margin-s">
          <p className="secondary-text bottom-margin-xs">
            L. Carrol &#183; 24/07/2024
          </p>
        </div>
        <p className="heading4 bottom-margin-s">Sobre perda e controle do peso</p>


        <p className="body content bottom-padding-s">
            Controlar meu peso foi a primeira coisa onde foquei depois do meu diagnóstico com colesterol alto. Eu estava com obesidade, e precisava reduzir meu peso de maneira sustentável e saudável. Com isso em mente, estudei e apliquei o que aprendi. <br/><br/>Algumas coisas que não sabia, mas que me aproximaram da realidade, são que pessoas que estão acima do seu peso ideal tem:<br/><br/>1) Maior risco de tornarem-se diabéticos.<br/>2) Maior risco de tornarem-se hipertensos.<br/>3) Maior risco de câncer de mama.<br/>4) Maior risco de câncer de cólon.<br/>5) Existe uma correlação direta entre sobrepeso e doenças cardíacas.<br/><br/>Com conhecimento sobre esses pontos comecei a trabalhar em desenvolver uma alimentação que me permitisse perder peso, e sustentar meu novo peso saudável. Notem aqui algo super importante, que nem sempre é evidente: a sua dieta para perda de peso precisa ser a sua nova rotina de alimentação como um todo, e não algo que você vai fazer algumas semanas enquanto perde peso, e depois vai parar e voltar para o que era antes. Se isso acontecer, todo o peso que você perdeu vai voltar em pouco tempo e com alguns kilos a mais.<br/><br/>PONTO CHAVE: A dieta de perda de peso precisa se tornar a nova rotina de alimentação como um todo.<br/><br/>Então, o ponto chave é: sua alimentação para perda de peso precisa ser sua alimentação para sustentar aquele peso. Ou seja, precisa ser sua nova educação alimentar, seu novo e permanente estilo de vida para alimentação.<br/><br/>Para montar seu novo estilo de vida alimentar é legal ter a ajuda de um nutricionista que te conhece. Mas alguns pontos gerais que eu usei e podem ser úteis:<br/><br/>O número de calorias que você consome menos o número de calorias que você queima determina se você irá ganhar ou perder peso. É importante focar em comidas que irão te dar a sensação de estar cheio/satisfeito com o menor número de calorias: comidas ricas em fibra, frutas e vegetais são ótimas opções, e devem fazer parte integral da nova alimentação (foque em no mínimo 3 frutas por dia!).<br/><br/>Corte os lanches durante o dia e a sobremesa enquanto você estiver tentando perder peso. E após ter chegado no seu peso ideal, esses lanches devem ser frutas.<br/><br/>Cuidado com o tamanho das porções. Mas coma quantos vegetais e frutas quiser, esses são livres!<br/><br/>Evite frituras. Elas adicionam cerca de um terço a mais de calorias. Prefira grelhados ou assados.<br/><br/>Faça exercícios: suas chances de perder peso e manter o peso ideal são muito melhores se você se exercitar. Até mesmo uma caminhada algumas vezes por dia é 1000 vezes melhor do que ficar sentado na frente da TV.
        </p>


        <div className="post-stats bottom-padding-xs">
          <button onClick={()=>{navigate('/forum/9')}} className="svg-btn">
            <div className="post-useful-info">
              <div> 
               <img src={LikeIcon} alt="Button indicating if you found this useful" />
              </div>
              <p className="secondary-text">
                  1 pessoa achou útil
              </p>
            </div>
          </button>

          <div className="post-useful-info"> 
            <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
            <p className="secondary-text">
              1 comentário
            </p>
          </div> 
        </div>
        <div className="top-padding-xs">

              <div className="comment-background comment">
                <p className="body comment-fixed">
                  Oi! Que post incrível e cheio de dicas valiosas! Parabéns pela sua determinação e por compartilhar seu conhecimento com a gente – isso pode fazer uma diferença enorme na vida de outras pessoas que estão enfrentando o mesmo desafio.<br/><br/>Eu queria só reforçar umas coisinhas para quem está começando nessa jornada:<br/><br/>1. **Procure um Nutricionista**: Mesmo seguindo dicas gerais, cada pessoa é única. Um nutricionista pode ajudar a criar um plano alimentar que se encaixe direitinho nas suas necessidades e gosto, e garantir que você receba todos os nutrientes necessários.<br/><br/>2. **Tenha Paciência**: A perda de peso sustentável leva tempo. Mude seus hábitos aos poucos para que eles virem parte da sua rotina.<br/><br/>3. **Hidrate-se**: Às vezes, confundimos a sede com fome. Beber bastante água ao longo do dia ajuda nesse processo.<br/><br/>4. **Dê Valor às Pequenas Vitórias**: Cada quilo perdido, cada escolha alimentar saudável conta! Fique orgulhoso(a) de cada passo que você der nessa direção.<br/><br/>E, pra galera que está lendo isso, sempre que tiverem dúvidas ou enfrentarem dificuldades, não hesitem em pedir ajuda. Vocês não estão sozinhos nessa caminhada!<br/><br/>Muito obrigada por compartilhar seu relato e parabéns novamente pela sua determinação e sucesso. Tudo de melhor pra você!<br/><br/>Abraços,<br/>Florence
                </p>
              </div>

              <div className="post-stats">
                <div className="bottom-margin-s">
                  <p className="secondary-text bottom-margin-xs">
                    Florence Health &#183; 06/08/2024
                  </p>
                </div>
              </div>


          <Button type="primary bottom-margin-s" onClick={()=>{navigate('/forum/9')}}>Comentar</Button>
        </div>

        <div className="top-padding-s">
          <p className="heading4 bottom-padding-xs bottom-border">Postagens Relacionadas</p>


              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Paula Farber &#183; 10/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/59-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Boa tarde pessoal, meu médico me mandou tomar cloridrato clomipramina 25mg pra pressão alta, mas não estou me adaptando. Tomo depois do almoço, mas estou tendo insônia e ele me deixa meio lenta, meio lesada. E não está resolvendo a pressão também. Alguém aqui toma ele?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/59')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    L. Carrol &#183; 23/07/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/7-geral" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Colesterol bom e colesterol ruim  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Uma das primeiras coisas que descobri depois do diagnóstico de colesterol alto foi que existem dois tipos de colesterol: o colesterol ruim (LDL) e o colesterol do bem (HDL). O colesterol total é a soma desses dois, e colesterol alto é ruim porque quando ele está alto, a maior parte dele é composta do colesterol ruim (LDL). <br/><br/>Importante: Pessoas com colesterol alto têm cerca de o dobro do risco de desenvolverem uma doença cardíaca em comparação com pessoas com níveis de colesterol normais.<br/><br/>Assim, para melhorar o colesterol, o que precisamos fazer é tentar REDUZIR nosso colesterol ruim (LDL) enquanto AUMENTAMOS nosso colesterol bom (HDL). <br/><br/>A primeira causa de termos alto colesterol ruim (LDL) é comer comidas que têm gorduras ruins para nós (gorduras trans e gorduras saturadas). O colesterol bom (HDL) ajuda a combater e reduzir o colesterol ruim (LDL), e quantidade muito baixa dele é uma causa de doença cardíaca.<br/><br/>Os três fatores SOB NOSSO controle que influenciam nosso colesterol (aumentam o bom, reduzem o ruim) são:<br/><br/>1) Nosso peso: Obesidade pode aumentar nosso colesterol ruim (LDL) até 50%, ao mesmo tempo que pode reduzir nosso colesterol bom (HDL) em 20%.<br/><br/>2) O que nós comemos: Tem muita coisa para falar aqui, mas o importante é comer saudável: frutas, verduras, fibras, peixes. Evitar comida processada, frituras, carne vermelha.<br/><br/>3) Exercício físico: Exercício é o último fator porque ele influencia os outros dois: pessoas que se exercitam tendem a comer melhor e pesar menos. Exercício também é chave para fortalecer o músculo do coração.<br/><br/>Aprender sobre esses pontos me ajudou muito no início da minha melhora de saúde, e espero que possa servir para vocês também.<br/>
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/7')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            1 pessoa achou útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        Nenhum comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Mario César &#183; 06/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/23-diabetes" reloadDocument={true}>

                  <p className="heading4 primary-color bottom-margin-xs">
                    Chá para diabético  
                  </p>

                  <p className="body primary-color content bottom-padding-xs">
                    Nao estou tomando medicamento<br/>O médico disse que posso controlar com dieta só<br/>Vocês tem chá bom pra diabetes?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/23')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            4 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Martina Coelho &#183; 13/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/86-cancer" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal<br/>Fui diagnosticada com câncer de mama há 1 semana, e estou sem chão, parece que o mundo perdeu o sentido…<br/>Confesso que minha vontade é só de ficar deitada na cama, no escuro, sozinha...<br/>Estou desde o dia do diagnóstico sem trabalhar, amanhã terei q voltar, mas só em pensar que terei q encarar os olhos das pessoas me olhando com dó, me já me dá uma ansiedade
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/86')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            5 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>

              <div className={"post-thumbnail top-padding-xxs bottom-padding-xxs"}>
                <div className="">
                  <p className="secondary-text bottom-margin-xs">
                    Marlene Techini &#183; 07/08/2024
                  </p>
                </div>
                <Link className="thumbnail-link" to="/post/35-pressao" reloadDocument={true}>

                  <p className="body primary-color content bottom-padding-xs">
                    Oi pessoal<br/>Alguém trocou propranolol por metoprolol?<br/>Tem alguma diferença significativa?
                  </p>
                </Link>
                <div className="post-stats bottom-padding-xxs">
                  <div className="post-stats bottom-padding-xs">
                    <button onClick={()=>{navigate('/forum/35')}} className="svg-btn">
                      <div className="post-useful-info">
                        <div> 
                         <img src={LikeIcon} alt="Button indicating if you found this useful" />
                        </div>
                        <p className="secondary-text">
                            2 pessoas acharam útil
                        </p>
                      </div>
                    </button>

                    <div className="post-useful-info"> 
                      <img src={CommentIcon} alt="Icon indicating quantity of comments in post" />
                      <p className="secondary-text">
                        1 comentário
                      </p>
                    </div> 
                  </div>
                </div>
              </div>


        </div>

      </div>
    </div>
  )
}
